/* eslint-disable react/no-array-index-key */
import moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BoxList from 'layout/atoms/BoxList';
import BoxListElement from 'layout/atoms/BoxListElement';
import Header from 'layout/atoms/Header/Header';
import Grid from 'layout/molecules/Grid/Grid';
import Dashboard from 'layout/templates/Dashboard/Dashboard';
import { useAppDispatch } from 'store/index';
import { clearBreadcrumbs, setBreadcrumbs } from 'store/layoutSlice';
import releases from '../../constants/releases';
function ReleasesDashboard() {
    const { t, i18n } = useTranslation('common');
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(setBreadcrumbs([{ to: '/releases', name: t('RELEASES_NOTES') }]));
        return () => {
            dispatch(clearBreadcrumbs());
        };
    }, [dispatch, t]);
    return (React.createElement(Dashboard, null,
        React.createElement("div", { style: {
                maxWidth: 700,
                margin: '0 auto',
                padding: '12px 0',
            } },
            React.createElement(Grid, { gap: 12 }, releases.map((release) => {
                const date = moment(release.date, 'MM/YYYY').locale(i18n.language).format('MMMM YYYY');
                return (React.createElement("div", { key: release.date },
                    React.createElement(Header, { size: "m" }, date.charAt(0).toUpperCase() + date.slice(1)),
                    React.createElement(BoxList, null, release.versions.map((version) => (React.createElement(BoxListElement, { key: version.version, accordion: true, marker: version.version, header: version.title },
                        React.createElement("ul", null, version.notes.map((note, idx) => (React.createElement("li", { key: idx }, note))))))))));
            })))));
}
export default ReleasesDashboard;
